var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import AudioHandler from "../AudioHandler";
import NotificationHandler from "../NotificationHandler";
import UtilsPosition from "@/lib/utils/position";
import Point from "@/prefabs/core/Point";
import { NotificationType } from "@/types/Notification";
var DEFAULT_POINTS_SIZE = 200;
var DEFAULT_POINTS_EXP = { max: 250, min: 100 };
var overlap = function (scene, player, listener) {
    scene.physics.add.overlap(player.character, scene.points, function (a, b) {
        // 'a' ve 'b' türlerini kontrol edin
        if (!(a instanceof Phaser.GameObjects.GameObject) || !(b instanceof Point)) {
            return;
        }
        var player = a.parentContainer;
        var point = b;
        if (!point.visible)
            return;
        point.setVisible(false);
        scene.points_hidden.push(point);
        var _a = UtilsPosition.scale_to_world_position({
            x: Math.random(),
            y: Math.random(),
        }), x = _a.x, y = _a.y;
        var exp = Math.round(Math.random() * (DEFAULT_POINTS_EXP.max - DEFAULT_POINTS_EXP.min) +
            DEFAULT_POINTS_EXP.min);
        point.setValue(__assign(__assign({}, point.getValue()), { exp: exp, x: x, y: y }));
        listener(player, point);
    });
};
var init = function (scene) {
    scene.points = scene.physics.add.group({
        classType: Point,
    });
    scene.points_hidden = [];
    overlap(scene, scene.player, function (player, point) {
        NotificationHandler.getInstance().push({
            type: NotificationType.EXP,
            detail: {
                exp: point.getValue().exp,
            },
        });
        AudioHandler.getInstance().play("point.pickup");
    });
    for (var i = 0; i < DEFAULT_POINTS_SIZE; i++) {
        var _a = UtilsPosition.scale_to_world_position({
            x: Math.random(),
            y: Math.random(),
        }), x = _a.x, y = _a.y;
        var exp = Math.round(Math.random() * (DEFAULT_POINTS_EXP.max - DEFAULT_POINTS_EXP.min) +
            DEFAULT_POINTS_EXP.min);
        var point = new Point(scene, {
            id: "point-".concat(i),
            x: x,
            y: y,
            exp: exp,
        });
        scene.points.add(point, true);
    }
    scene.time.addEvent({
        callback: function () {
            if (!scene.points_hidden)
                return;
            var point = scene.points_hidden.pop();
            while (point) {
                point.setVisible(true);
                point = scene.points_hidden.pop();
            }
        },
        delay: 5000,
        loop: true,
    });
};
var PointHelper = { init: init, overlap: overlap };
export default PointHelper;
